import FormattedMessage from 'I18n/components/FormattedMessage';
import { MerchCardSubheadingContainer } from '../../../../v2/containers/merch-card/headings-display/MerchCardSubheadingContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuiteCardSubheading = ({
  productLevel
}) => {
  if (productLevel === 'STARTER') return /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.suiteTile.starterCard.description"
    }),
    apiName: "crm-suite-starter-bundle"
  });
  if (productLevel === 'PROFESSIONAL') return /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.suiteTile.professionalCard.description"
    }),
    apiName: "crm-suite-professional-bundle"
  });
  if (productLevel === 'ENTERPRISE') return /*#__PURE__*/_jsx(MerchCardSubheadingContainer, {
    Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.suiteTile.enterpriseCard.description"
    }),
    apiName: "crm-suite-enterprise-bundle"
  });
  return null;
};